var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ds-modal", {
    attrs: { open: _vm.showModal },
    scopedSlots: _vm._u([
      {
        key: "body",
        fn: function () {
          return [
            _c("div", { staticClass: "modal-dialog go-modal-connect" }, [
              _c("div", { staticClass: "modal-content" }, [
                _c("div", { staticClass: "modal-header" }, [
                  _c("div", { staticClass: "modal-title" }, [
                    _vm._v(_vm._s(_vm.$t("scrap-agent.login"))),
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn go-btn-icon close",
                      attrs: { type: "button", "data-dismiss": "modal" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.handleCloseModal.apply(null, arguments)
                        },
                      },
                    },
                    [_c("i", { staticClass: "go-icon-24 go-icon-close" })]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [
                  _c("div", { staticClass: "go-form-connect-login" }, [
                    _c("div", { staticClass: "go-form-header" }, [
                      _c("div", { staticClass: "go-brand" }, [
                        _c("div", { staticClass: "go-brand-symbol" }, [
                          _c("img", {
                            attrs: {
                              src:
                                _vm.syncedChannelConnect.channelImageUri ||
                                "https://blogpfthumb-phinf.pstatic.net/MjAxOTA2MThfMjE2/MDAxNTYwODM2ODQ5MDk5.QteT5YL-OesHK0KxOdLg_5sTkIOvAqT10uVjT8rdNrsg.IIvp-gexFczdgl3bbJL4riqyDoTLAJkXOSSbfJEB6JUg.PNG.blogpeople/%255BTeamBlog%255DProfile%25402x.png?type=s1",
                              alt: _vm.syncedChannelConnect.channelType,
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _c("p", [_vm._v(_vm._s(_vm.nameModal))]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "go-form-body" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", { staticClass: "go-form-label" }, [
                          _vm._v(_vm._s(_vm.$t(_vm.login.username))),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "go-input-group" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.formData.accountName,
                                expression: "formData.accountName",
                              },
                            ],
                            staticClass: "go-form-control",
                            attrs: {
                              type: "text",
                              placeholder: _vm.$t(
                                _vm.login.placeholderUsername
                              ),
                            },
                            domProps: { value: _vm.formData.accountName },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.formData,
                                  "accountName",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _vm.invalidAccount
                          ? _c("div", { staticClass: "go-form-feedback" }, [
                              _c(
                                "div",
                                { staticClass: "go-form-feedback-invalid" },
                                [_vm._v(_vm._s(_vm.$t(_vm.invalidText)))]
                              ),
                            ])
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", { staticClass: "go-form-label" }, [
                          _vm._v(_vm._s(_vm.$t(_vm.login.password))),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "go-input-group" }, [
                          (_vm.showPassword ? "text" : "password") ===
                          "checkbox"
                            ? _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.formData.password,
                                    expression: "formData.password",
                                  },
                                ],
                                staticClass: "go-form-control",
                                attrs: {
                                  placeholder: _vm.$t(
                                    _vm.login.placeholderPassword
                                  ),
                                  type: "checkbox",
                                },
                                domProps: {
                                  checked: Array.isArray(_vm.formData.password)
                                    ? _vm._i(_vm.formData.password, null) > -1
                                    : _vm.formData.password,
                                },
                                on: {
                                  change: function ($event) {
                                    var $$a = _vm.formData.password,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          _vm.$set(
                                            _vm.formData,
                                            "password",
                                            $$a.concat([$$v])
                                          )
                                      } else {
                                        $$i > -1 &&
                                          _vm.$set(
                                            _vm.formData,
                                            "password",
                                            $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1))
                                          )
                                      }
                                    } else {
                                      _vm.$set(_vm.formData, "password", $$c)
                                    }
                                  },
                                },
                              })
                            : (_vm.showPassword ? "text" : "password") ===
                              "radio"
                            ? _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.formData.password,
                                    expression: "formData.password",
                                  },
                                ],
                                staticClass: "go-form-control",
                                attrs: {
                                  placeholder: _vm.$t(
                                    _vm.login.placeholderPassword
                                  ),
                                  type: "radio",
                                },
                                domProps: {
                                  checked: _vm._q(_vm.formData.password, null),
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$set(
                                      _vm.formData,
                                      "password",
                                      null
                                    )
                                  },
                                },
                              })
                            : _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.formData.password,
                                    expression: "formData.password",
                                  },
                                ],
                                staticClass: "go-form-control",
                                attrs: {
                                  placeholder: _vm.$t(
                                    _vm.login.placeholderPassword
                                  ),
                                  type: _vm.showPassword ? "text" : "password",
                                },
                                domProps: { value: _vm.formData.password },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.formData,
                                      "password",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "toggle-password",
                              attrs: { type: "button" },
                              on: { click: _vm.togglePassword },
                            },
                            [
                              _c("span", {
                                staticClass: "go-icon-16",
                                class: _vm.showPassword
                                  ? "go-icon-hidden"
                                  : "go-icon-view",
                              }),
                            ]
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "go-btn-block" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn go-btn-login",
                            attrs: { type: "submit", disabled: _vm.invalid },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.handleShowAccountList.apply(
                                  null,
                                  arguments
                                )
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                  " +
                                _vm._s(_vm.$t("scrap-agent.login")) +
                                "\n                "
                            ),
                          ]
                        ),
                      ]),
                    ]),
                  ]),
                ]),
              ]),
            ]),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }